interface LinkType {
    title: string;
    linkTo: string;
  }
  
  export const LinksData: LinkType[] = [
    {
      title: 'Home',
      linkTo: '/',
    },
    {
      title: 'Skills',
      linkTo: '/skills',
    },
    {
      title: 'Experience',
      linkTo: '/experience',
    },
    {
      title: 'Projects',
      linkTo: '/projects',
    },
    {
      title: 'Contact',
      linkTo: '/contact',
    },
  ];